import type { FormConfig, PropertySchema } from '@takeshape/schema';
import type { List } from 'immutable';
import type { ImmutableMap } from './immutable-types.js';

export type WidgetOption = {
  label: string;
  value: unknown;
};

export default function getWidgetOptions(
  schema: ImmutableMap<PropertySchema>,
  config?: ImmutableMap<FormConfig>
): WidgetOption[] {
  let options = [];

  const configuredOptions = config?.get('options');
  const sharedNameValueEnum = schema.get('enum');
  if (configuredOptions) {
    options = configuredOptions.toJS();
  } else if (sharedNameValueEnum) {
    options = sharedNameValueEnum.toArray().map((tzName) => ({
      label: tzName,
      value: tzName
    }));
  } else {
    const oneOf: List<ImmutableMap<PropertySchema>> | undefined =
      schema.get('type') === 'array' ? schema.getIn(['items', 'oneOf']) : schema.get('oneOf');
    if (oneOf) {
      options = oneOf.toArray().map((optionSchema: ImmutableMap<PropertySchema>) => ({
        label: optionSchema.get('title'),
        value: optionSchema.getIn(['enum', 0])
      }));
    }
  }

  return options;
}
